import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/Button/Button';
import { PageHeader } from 'shared/components/PageHeader';
import { useTheme } from 'context/ThemeContext';
import { ALLOW_SUBSCRIPTIONS } from 'shared/constants/common';

interface Props {
  hasEvents?: boolean
}

export function HeroSection({hasEvents}: Props) {
  const { t } = useTranslation('community');
  const { theme } = useTheme();
  return (
    <section className="relative flex items-center pt-32 pb-12 md:pt-40 md:pb-20 -mt-24">
      <div className="absolute inset-0 -bottom-24 z-0">
        <img
          src={theme === 'light' ? '/images/backgrounds/community-hero-bg-light.png' : '/images/backgrounds/community-hero-bg.jpg'}
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-surface/40" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">
        <PageHeader
          label={t('hero.label')}
          title={t('hero.heading')}
          titleHighlight={t('hero.highlight')}
          description={t('hero.description')}
        >
          {hasEvents || ALLOW_SUBSCRIPTIONS ? <div className="flex flex-wrap gap-4 mt-10">
            {ALLOW_SUBSCRIPTIONS ? <Button variant="gold" size="lg">
              {t('hero.subscribeCta')}
            </Button> : null}
            {hasEvents ? <Button variant="ghost" size="lg">
              {t('hero.calendarCta')}
            </Button> : null}
          </div> : null}
        </PageHeader>
      </div>
    </section>
  );
}
